import { render } from "./MiezzCustomsProductDetail.vue?vue&type=template&id=7bc1b4f0&scoped=true&ts=true"
import script from "./MiezzCustomsProductDetail.vue?vue&type=script&lang=ts"
export * from "./MiezzCustomsProductDetail.vue?vue&type=script&lang=ts"

import "./MiezzCustomsProductDetail.vue?vue&type=style&index=0&id=7bc1b4f0&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc1b4f0"]])

export default __exports__